// Back-compat wrapper: existing Quiz Live code imports from ../quiz/services/sessionService
// We keep the same API but delegate to the new implementation in src/quizLive.

import type { LiveMode, LiveSession, QuizQuestion } from '../types';
import {
  ensureAnonymousAuth,
  joinSessionAsParticipant,
  listenLiveSession,
  listenParticipants,
  submitAnswer,
  startLiveQuestion,
  finalizeLiveResults,
  goToLobby,
  endSession,
  resolveSessionIdByCode,
  createLiveSession as createLiveSessionV2
} from '../../quizLive/sessionService';

export { ensureAnonymousAuth, joinSessionAsParticipant, listenLiveSession, listenParticipants, submitAnswer, startLiveQuestion, finalizeLiveResults, goToLobby, endSession };

export async function createLiveSession(params: {
  deckId: string;
  hostUserId: string;
  mode: LiveMode;
  showLeaderboard: boolean;
  inclusive: boolean;
  defaultTimeSec: number;
  expiresInHours?: number;
}): Promise<{ sessionId: string; pin: string }> {
  const { sessionId, joinCode } = await createLiveSessionV2({
    hostUserId: params.hostUserId,
    mode: 'presentation',
    quizRef: { type: 'deck', deckId: params.deckId },
    liveMode: params.mode,
    showLeaderboard: params.showLeaderboard,
    inclusive: params.inclusive,
    defaultTimeSec: params.defaultTimeSec,
    expiresInHours: params.expiresInHours
  });

  // `pin` for legacy UI = joinCode (may contain letters)
  return { sessionId, pin: joinCode };
}

export async function resolveSessionIdByPin(pinOrCode: string): Promise<string | null> {
  return resolveSessionIdByCode(pinOrCode, { retries: 3 });
}
